export default () => ({
  list: [],
  planStatus: {
    1: '下書き',
    2: '全体公開',
    3: '限定公開',
  },
  planType: {
    1: '',
    2: 'モチカケ_スタンダード',
    3: 'モチカケ_ビジネスプラン',
    4: 'モチカケ_プロフェッショナル',
  },
  showOption: {
    0: '表示されません',
    1: '見せる'
  }
})
